import { render, staticRenderFns } from "./contract-main-details.component.vue?vue&type=template&id=aee2a814"
import script from "./contract-main-details.component.vue?vue&type=script&lang=ts"
export * from "./contract-main-details.component.vue?vue&type=script&lang=ts"
import style0 from "./contract-main-details.component.vue?vue&type=style&index=0&id=aee2a814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports